import React from 'react';
import { OPEN_STATUSES, CLOSED_STATUSES } from '../lib/utils';

const is = (...statuses) => (s) => statuses.includes(s.status);

export const FILTERS = {
  all             : (s) => OPEN_STATUSES.includes(s.status),
  closed          : (s) => CLOSED_STATUSES.includes(s.status),
  intake          : is('processing', 'enriching'),
  nbi_ready       : is('nbi_ready'),
  data_incomplete : is('data_incomplete'),
  nbi_sent        : is('nbi_sent'),
  assessment      : is('assessment_sent', 'in_progress'),
  ready_to_quote  : is('ready_to_quote'),
  review_incomplete: is('review_incomplete'),
  quoted          : is('quote_sent', 'ready_to_bind'),
  referred        : is('referred'),
  bound           : is('policy_issuance'),
  declined        : is('appetite_decline', 'declined', 'not_taken', 'cancelled'),
};

export default function Sidebar({ submissions, filter, setFilter }) {
  const list  = submissions || [];
  const count = (fn) => list.filter(fn).length;

  const item = (key, label, opts = {}) => (
    <NavItem
      active={filter === key}
      badge={count(FILTERS[key])}
      badgeHot={opts.hot}
      onClick={() => setFilter(key)}
    >
      {label}
    </NavItem>
  );

  return (
    <nav style={{
      background:'var(--surface)', borderRight:'1px solid var(--border)',
      padding:'24px 0', display:'flex', flexDirection:'column',
      gap:2, overflowY:'auto'
    }}>
      <NavSection>Submissions</NavSection>
      {item('all', 'All Open', { hot: true })}
      {item('intake', 'Intake')}

      <NavSection>Action Required</NavSection>
      {item('nbi_ready', 'NBI Ready', { hot: true })}
      {item('data_incomplete', 'Data Incomplete')}
      {item('ready_to_quote', 'Ready to Quote', { hot: true })}
      {item('review_incomplete', 'Review Incomplete')}
      {item('referred', 'Referred')}

      <NavSection>In Flight</NavSection>
      {item('nbi_sent', 'NBI Sent')}
      {item('assessment', 'Assessment')}
      {item('quoted', 'Quoted')}

      <NavSection>Closed</NavSection>
      {item('bound', 'Bound')}
      {item('declined', 'Declined / Lost')}

      <NavSection>Analytics</NavSection>
      <NavItem onClick={() => {}}>Dashboard</NavItem>
      <NavItem onClick={() => {}}>Portfolio</NavItem>

      <NavSection>Admin</NavSection>
      <NavItem onClick={() => {}}>Appetite Config</NavItem>
      <NavItem onClick={() => {}}>Audit Log</NavItem>
    </nav>
  );
}

function NavSection({ children }) {
  return (
    <div style={{
      padding:'16px 20px 8px', fontSize:10,
      letterSpacing:'0.1em', textTransform:'uppercase',
      color:'var(--muted)'
    }}>
      {children}
    </div>
  );
}

function NavItem({ children, active, badge, badgeHot, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        display:'flex', alignItems:'center', gap:10,
        padding:'9px 20px', cursor:'pointer',
        color: active ? 'var(--text)' : 'var(--muted2)',
        background: active ? 'var(--surface3)' : 'transparent',
        fontSize:12, position:'relative', transition:'all 0.15s',
        borderLeft: active ? '2px solid var(--accent)' : '2px solid transparent',
      }}
    >
      {children}
      {badge != null && badge > 0 && (
        <span style={{
          marginLeft:'auto', fontSize:10, padding:'1px 6px', borderRadius:10,
          background: badgeHot ? 'var(--red-bg)' : 'var(--surface3)',
          border: `1px solid ${badgeHot ? 'var(--red-b)' : 'var(--border2)'}`,
          color: badgeHot ? 'var(--red)' : 'var(--muted2)',
        }}>
          {badge}
        </span>
      )}
    </div>
  );
}
